import { createAction, props } from '@ngrx/store';
import { ReferrerPortalBookingReason } from 'app/modules/referrer/book-online/models/referrer-portal-booking-reason.model';

export const setBookingReason = createAction(
  '[BookingReason] Set Booking Reason',
  props<{ bookingReason?: ReferrerPortalBookingReason }>()
);
